/* ltt-toast — one shared status line at the bottom of the screen.

   `window.lttToast(text)`. Owns no copy: every caller passes a string that came
   out of the theme locales via a Liquid data attribute.

   ONE toast for the page, not one slot per card. Product cards are rendered by
   a dozen sections and a per-card message slot would put markup on all ~60
   cards on the home page for a line at most one of them ever shows.

   role="status" (not "alert"): these are confirmations and gentle refusals, and
   assertive live regions interrupt a screen reader mid-sentence. The node is
   created once and reused, so the live region is registered before the first
   message lands in it — a region inserted and filled in the same tick is
   commonly missed by screen readers. */
(function () {
  'use strict';
  if (window.lttToast) return;

  var node = null;
  var timer = null;

  window.lttToast = function (text) {
    if (!text) return;
    if (!node) {
      node = document.createElement('div');
      node.className = 'ltt-toast';
      node.setAttribute('role', 'status');
      document.body.appendChild(node);
    }
    node.textContent = text;
    /* Re-triggering while it is still up must replay the animation rather than
       do nothing, so drop the class and force a reflow before re-adding it. */
    node.classList.remove('is-open');
    void node.offsetWidth;
    node.classList.add('is-open');
    clearTimeout(timer);
    timer = setTimeout(function () {
      node.classList.remove('is-open');
    }, 4000);
  };
})();
